import { createStyles, makeStyles } from '@hawkins/styles';
export var TIER_1_HEIGHT = 72;
export var TIER_2_HEIGHT_ANIMATION_DURATION = 200;
export function horizontalNavigationStyles(theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    var tier1BoxShadow = hawkins.elevation.boxShadow2;
    var tier2Height = hawkinsVariables.sizingValues.size6 + 2;
    return createStyles({
        /** Class name of the element containing the component’s children. */
        childrenContainer: {
            alignItems: 'center',
            display: 'flex',
            flexGrow: 1,
            gap: hawkinsVariables.spacings.space1,
            // Flex items have `min-width: auto` by default.
            // Need to set `min-width: 0` to support overflow menu functionality (see https://stackoverflow.com/a/36247448).
            minWidth: 0,
        },
        /** Class name of the element containing the application logo and name. */
        logoContainer: {
            gridArea: 'logo',
        },
        /** Class name of the root element. */
        root: {
            zIndex: hawkinsVariables.zIndexes.appBar,
        },
        /** Class name of the root element when the component is fixed. */
        rootFixed: {
            position: 'sticky',
            top: 0,
        },
        /** Class name of the tier 1 element. */
        tier1: {
            alignItems: 'center',
            backgroundColor: hawkins.elevation.backgroundColor2,
            boxShadow: tier1BoxShadow,
            columnGap: hawkinsVariables.spacings.space5,
            display: 'grid',
            gridTemplate: "\n        \"logo tier-1-main-content\" ".concat(TIER_1_HEIGHT, "px\n        \". tier-2-content\" ").concat(tier2Height, "px\n        / min-content 1fr\n      "),
            height: TIER_1_HEIGHT,
            padding: "0 ".concat(hawkinsVariables.spacings.space5),
            position: 'relative',
            transition: 'box-shadow 0.2s ease-in-out',
            zIndex: hawkinsVariables.zIndexes.appBar,
        },
        /** Class name of the element containing the main content of tier 1. */
        tier1MainContent: {
            alignItems: 'center',
            display: 'flex',
            gap: hawkinsVariables.spacings.space5,
            gridArea: 'tier-1-main-content',
            // Flex items have `min-width: auto` by default.
            // Need to set `min-width: 0` to support overflow menu functionality (see https://stackoverflow.com/a/36247448).
            minWidth: 0,
        },
        /** Class name of the tier 1 element when the navigation component is transparent. */
        tier1Transparent: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
        },
        /** Class name of the tier 1 element when tier 2 is visible. */
        tier1WithTier2: {
            boxShadow: tier1BoxShadow,
        },
        /** Class name of the tier 2 element. */
        tier2: {
            backgroundColor: hawkins.elevation.backgroundColor1,
            boxShadow: hawkins.elevation.boxShadow1,
            height: tier2Height,
            maxHeight: 0,
            transition: "max-height ".concat(TIER_2_HEIGHT_ANIMATION_DURATION, "ms ease-in-out"),
        },
        /** Class name of the element containing the content of tier 2. */
        tier2Content: {
            alignItems: 'center',
            display: 'flex',
            gap: hawkinsVariables.spacings.space1,
            gridArea: 'tier-2-content',
        },
        /** Class name of the tier 2 element when tier 2 is visible. */
        tier2Expanded: {
            maxHeight: tier2Height,
            transition: "max-height ".concat(TIER_2_HEIGHT_ANIMATION_DURATION, "ms ease-in-out"),
        },
        /** Class name of the tier 2 element when the navigation component is transparent. */
        tier2Transparent: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
        },
    });
}
export var useHorizontalNavigationStyles = makeStyles(horizontalNavigationStyles, {
    name: 'Hawkins-HorizontalNavigation',
});
